import {
  Component,
  Input,
  ViewChild,
  OnInit,
  OnChanges,
  SimpleChanges,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  HostListener,
  ViewEncapsulation,
  Inject,
  DoCheck,
  Renderer2,
} from "@angular/core";
import { Question } from "../question/question.model";
import { Reply } from "../reply/reply.model";
import { QuestionService } from "../question/question.service";
import { ReplyService } from "../reply/reply.service";
import { ReplyComponent } from "../reply/reply.component";
import { AttachmentUploaderComponent } from "../shared/attachment-uploader/attachment-uploader.component";
import { ToastrService } from "ngx-toastr";

import { TranslationService } from "../translation/translation.service";
import { AppState } from "../app.service";
import { Path } from "../path/path-v2.model";
import { Router } from "@angular/router";
import { Apollo } from "apollo-angular";
import { CordovaService } from "../cordova.service";
import { I18n } from "../i18n.service";
import { SessionService } from "../session/session.service";
import { Observable } from "rxjs";
import { bounceInAnimation, slideOutRightAnimation } from "angular-animations";
import { AlertUserLikeListComponent } from "../alert-user-like-list/alert-user-like-list.component";
import { MobileChatBoardComponent } from "../pages/mobile-chat-board/mobile-chat-board.component";
import { MobileChatServiceService } from "../pages/mobile-chat-board/mobile-chat-service.service";
import { WINDOW } from "../window.service";
import { WalletService } from "../wallet/wallet.service";
import { RoutineInfo } from "../routine-v2/routine-info.model";
import { RoutineV2Service } from "../routine-v2/routine-v2.service";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SpinnerService } from "../spinner.service";
import { IonInput, ModalController, NavController, Platform, PopoverController } from "@ionic/angular";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { UserPublicProfileComponent } from "../components/user-public-profile/user-public-profile.component";
import { AnalyticsServiceService } from "../services/analytics-service.service";
import { RoutineService } from "../daily-content-v2/routine.service";
import { Keyboard } from "@awesome-cordova-plugins/keyboard/ngx";
import { HomeUiService } from "../new-design/home-ui.service";
import { KyperDataApiService } from "../services/kyper-data-api.service";

@Component({
  selector: 'app-full-screen-routine',
  templateUrl: './full-screen-routine.component.html',
  styleUrls: ['./full-screen-routine.component.scss'],
  animations: [slideOutRightAnimation({duration:300})]
})

export class FullScreenRoutineComponent implements OnInit, AfterViewInit, DoCheck {
  @Input() mode: string = "routine";
  @Input() isPreview: boolean;
  @Input() inverted: boolean = false;
  @Input() small = false;
  @Output() closed: EventEmitter<any>;
  @Output() itemSelected: EventEmitter<any>;
  @Input() replyId;
  @ViewChild("uploader") uploader: AttachmentUploaderComponent;
  @ViewChild("replyBlock") replyBlock: ElementRef;
  @ViewChild("repliesContainer") repliesContainer: ElementRef;
  @ViewChild("textareaForFeeds") txtarea_post: ElementRef;
  @ViewChild('btn') btn: ElementRef;
  textareaContentLength =0;
  @ViewChild('h1')
  h1: ElementRef;
  @Input() data;
  @Input() focuseTextArea;
  isTranslated;
  flag;
  isLoaded =false;
  path: Path;
  isTextboxHide =true
  rightState= false
  ishideComment: boolean = false;
  sortBy: string = "timestamp";
  replyText: string = "";
  cachedReplyText: string = ""; // LUMBA-1383
  attachmentUrl: string = null;
  errors: { answerError: false };
  replyTo: Reply = null;
  replyToComponent: ReplyComponent;
  replyToId: number;
  @ViewChild('replyComponent') replyComponent: ReplyComponent;
  isLoading: boolean = false;
  replyOffset: number;
  selected: boolean = false;
  voteLoading: boolean = false;
  user: any;
  routine;
  tagName_id: number
  dataOfUser: Observable<any>;
  namesData: any[]
  tempData: any
  state: boolean = false;
  animation = ['bounceIn'];
  isScrolledBottom: boolean = false
  color: string
  // backgroundColor = '#a972cb';
  // svgIcon = 'https://img.icons8.com/emoji/24/000000/white-heart.png';
  singleRoutineAnswer: any
  signleRoutine: any
  private _optimisticIdCounter = -1;
  userDetails;
  public replies: Reply[]
  public repliesTree: any[] =[]
  public repliesIdsMap: Map<number, number>
  public masterRoutineAnswer: any
  isMobile: boolean
  page;
  apiRepliesCount = 0;
  replyCount = 0;
  pathRegistration
  constructor(
    private i18n: I18n,
    private apollo: Apollo,
    private router: Router,
    private appState: AppState,
    private toastrService: ToastrService,
    private questionService: QuestionService,
    private replyService: ReplyService,
    private translationService: TranslationService,
    private spinnerService: SpinnerService,
    private cordovaService: CordovaService,
    private sessionService: SessionService,
    private mobileService: MobileChatServiceService,
    private dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private toasterService: ToastrService,
    private walletService: WalletService,
    private routineV2Service: RoutineV2Service,
    private nav: NavController,
    private routineService: RoutineService,
    private _bottomSheet: MatBottomSheet,
    private modalController: ModalController,
    public platform: Platform,
    private analyticsService: AnalyticsServiceService,
    private keyboard: Keyboard,
    public homeUiService: HomeUiService,
    private popoverController:PopoverController,
    public render: Renderer2,
    private kyperService: KyperDataApiService,
    @Inject(WINDOW) private window: Window,
    // @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.path = this.appState.get("currentPath");
    this.user = this.appState.get("currentUser");
    this.pathRegistration = this.appState.get("pathRegistration");
    var dataOfFeeds = this.appState.get('singleFeed')
    var dataOfRoutineFeeds = this.appState.get('singleRoutineFeed')
    this.isMobile = this.appState.get('isMobile')
    this.page =1
    // this.singleRoutineAnswer = dataOfRoutineFeeds.singleRoutine
    // console.log('singleRoutineAnswer', this.singleRoutineAnswer);

    // this.tempData = dataOfFeeds["singleRoutine"]
    // this.mode = dataOfFeeds["mode"]
    // console.log('this.mode :', this.mode, this.path[dataOfFeeds["mode"]]);
    //     this.appState.set("mode", this.mode);
    // this.routine = this.sessionService.findById(this.path[dataOfFeeds["mode"]], this.tempData.id)
    // this.color = this.appState.get("routine_color")
    // this.appState.set('oldActionPoints', this.walletService.actionPoints.value)

    // this.masterRoutineAnswer = this.sessionService.findById(this.tempData.routineAnswerList, this.singleRoutineAnswer.id)
    // console.log('masterRoutineAnswer', this.masterRoutineAnswer);
    this.singleRoutineAnswer = this.appState.get('singleHabit')
    console.log("🚀 ~ FullScreenRoutineComponent ~ constructor ~ this.singleRoutineAnswer:", this.singleRoutineAnswer)
    this.appState.set('questionsLoaded', false)

  }

  ngOnInit() {
    this.getRoutineDetails(this.singleRoutineAnswer)
    setTimeout(()=>{
      if(this.focuseTextArea) {
        this.clickOnInput();
       }
    },600 )
    
    // this.isLoaded =false;
    //this.spinnerService.on();
    this.data = this.data;
    this.singleRoutineAnswer =this.data;
    console.log("🚀 ~ FullScreenRoutineComponent ~ ngOnInit ~ this.singleRoutineAnswer:", this.singleRoutineAnswer)
    this.analyticsService.setScreen(AnalyticsServiceService.FULLROUTINE)
    this.appState.set('communityNotification', undefined)
    this.appState.set('notificationData', undefined)
  }

  async ngDoCheck() {
    // Only the view that OWNS the deleted comment may consume the GLOBAL commentDeleted flag. The
    // deleter (reply/comment component) stamps repliesTreeObject with the tree it was rendered from,
    // so a reference match identifies the owning view. Consuming it unconditionally STOLE the flag
    // from the community list components (comments-list-web / habit-comment-list-web) whose
    // ngDoCheck splice then never ran — the deleted comment stayed on screen in the individual AND
    // All tabs until the modal was reopened, even though the delete API succeeded.
    // `owner &&` (not a bare !==) so a delete made from THIS full-screen view — where no tree is
    // stamped — still refreshes as before; we only ever bow out when another view is the stamped owner.
    const owner = this.appState.get('repliesTreeObject');
    if (owner && owner !== this.repliesTree) { return; }
    let isCommentDeleted = this.appState.get('commentDeleted')
    if (isCommentDeleted) {
      this.appState.set('commentDeleted', undefined)
      this.page = 1;
      // Refetch THIS post (as everywhere else in this component) rather than the global
      // 'singleHabit', which can be stale or null for the post actually on screen.
      await (this.getRoutineDetails(this.singleRoutineAnswer))
       //this.removeDeletedComment();
    }
  }

  async removeDeletedComment() {
    let pageCount = this.page;
    console.log("pageCount", this.page, pageCount);
    this.page = 1;
    for (let i = 1; i < pageCount; i++) {
      try {
        // if(this.page ==1) {
        //   this.apiRepliesCount = 0;
        //   this.repliesTree = [];
        // }
      await (this.getRoutineDetails(this.singleRoutineAnswer)).then(() => {
        this.page += 1;
      });
        
      } catch (error) {
        break; 
      }
    }
  }
  
  checkTextareaLength() {
    let len = this.replyText?.trim();
    this.textareaContentLength =len.length;
}
  ngAfterViewInit() {
    this.focusComment()
    window.scroll(0, 0);
    if(this.isMobile){
      if(this.platform.is('android')) {
       let id =document.getElementsByClassName('list-group')[0];
      //  id.setAttribute('style', 'margin-top:60px;')
        this.keyboard.onKeyboardDidShow().subscribe((info) => {
          const mobileLoginScreens = document.querySelector('.reply-container');
          mobileLoginScreens.setAttribute('style', `height: calc(100vh - ${info.keyboardHeight}px - 15px);`);

          console.log('keyboard will show with height', info.keyboardHeight);
          this.replyBlock.nativeElement.style.setProperty(
            'bottom',
            `${0}px`
          );
          this.replyBlock.nativeElement.style.setProperty(
            'padding-bottom',
            `${25}px`
          );
        });
    
        this.keyboard.onKeyboardDidHide().subscribe(() => {
          const mobileLoginScreens = document.querySelector('.reply-container');
          mobileLoginScreens.setAttribute('style', `height: 100vh;`);
          console.log('keyboard did hide');
          this.replyBlock.nativeElement.style.setProperty(
            'bottom',
            `${0}px`
          );
          this.replyBlock.nativeElement.style.setProperty(
            'padding-bottom',
            `${20}px`
          );
        });
      }
      if (this.platform.is('ios')) {
         this.keyboard.onKeyboardDidShow().subscribe((info) => {
          let mobileLoginScreens = document.querySelector('.reply-container');
          mobileLoginScreens.setAttribute('style', `height: calc(100vh - ${info.keyboardHeight}px);`);
        });
    
        this.keyboard.onKeyboardWillHide().subscribe(() => {
         let mobileLoginScreens = document.querySelector('.reply-container');
          mobileLoginScreens.setAttribute('style', `height: 100vh;`);
          
        });
      }
    }
    //this.showCommentsData(this.data);
    //     // this line moves the screen at the bottom scroll
    //this.replyOffset = 0;
  }

  showCommentsData(data) {
    let user ={
      email: data?.email,
     first_name: data?.first_name,
     id: data?.user_id,
     imageUrl: data?.image_url,
      last_name: data?.last_name,
      user_bg_color: data?.routine_color
    }
    this.userDetails=user;
          
             var level1 = data.replies;
             this.replyCount = data.replyCount;
            if (level1) {
              var subReply = level1.filter(item => item.repliableId)
              level1.forEach(reply => {
                if (!reply.replies) { reply.replies = []; }
                reply.timestamp = new Date(reply.createdAt);
                subReply.forEach((element: any) => {
                  if (element.repliableId === reply.id && !reply.replies.some((r: any) => r.id === element.id)) {
                    reply.replies.push(element);
                    reply.replies = [...new Set(reply.replies)];
                  }
                });
              });

              this.repliesTree = level1.filter(reply => reply.id && (reply.replyLevel === 1 || reply.level === 1))
              this.appState.set('repliesTreeObject', this.repliesTree);
              this.repliesTree.forEach((reply: any) => {
                if (!reply.subReplyCount) { reply.subReplyCount = reply.replies?.length ?? 0; }
              });
              this.isLoaded=true;

              this.appState.set('repliesLength', this.repliesTree?.length)
            }
  
  }
  onCommentClick() {
    this.txtarea_post?.nativeElement.focus();
      this.replyTo = null;
      this.replyToId = null;
  }

  itemMentioned(tag) {
    console.log("selected ", tag);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.routine || changes.routine.firstChange) {
      return false;
    }
    this.sortRepliesBy(this.sortBy)
    this.cdRef.detectChanges();
  }

  toggleSort(by: string) {
    console.log("by:" + by);
    this.sortBy = by;
    this.sortRepliesBy(this.sortBy)
  }

  orderingSubReplies(reply) {
    this.isLoaded = true;
    this.isTextboxHide = true;
    this.appState.set("isMobileReply", false);
    // this.commentCount = reply.replyCount;
    // this.data.votescount = reply?.voteCount;
    let replySort;
    this.data.replyCount = this.data.replyCount+1;
    this.replyCount = this.data.replyCount;
    var level1 = [reply, ...this.repliesTree];
    if (level1) {
      var subReply = level1.filter(item => item.repliableId)
      level1?.forEach(reply => {
        subReply?.forEach(element => {
          if (element?.repliableId === reply.id) {
            const updatedReply = { ...reply };
            updatedReply.replies = [element, ...updatedReply.replies];
            updatedReply.timestamp = new Date(reply.createdAt);
            //replySort =updatedReply;
            const index = level1.findIndex(r => r.id === updatedReply.id);
            level1[index] = updatedReply;
          }
        });
      });
      // if (replySort) {
      //   replySort.timestamp = new Date(reply.createdAt);
      // }
    //  let index =level1?.findIndex((reply) => reply.id == replySort.id)
    //   level1.splice(index,1)
      let repliesTree = level1.filter(reply => reply.id && reply.replyLevel === 1)
      this.repliesTree = repliesTree;
      // this.appState.set('repliesTreeObject', this.repliesTree);
      this.data.replies = this.repliesTree;
      console.log("repliestree in comment list", this.repliesTree);
    }
  }
  reply() {
    if(this.textareaContentLength>0){
      this.isLoaded =false
    }
    if(this.replyTo) {
      this.appState.set('isMobileReply',true)
      this.isTextboxHide =false;
     }
    let formatedText;
    if (this.replyText.length == 0) {
      this.isLoaded =true
      this.toastrService.error(this.i18n.t('Please enter a comment'), this.i18n.t('Error'))
      return false;
    }

    var list_of_tags_ids = []

    list_of_tags_ids = this.sessionService.getUserTAGs(this.replyText, this.complexItems)
    list_of_tags_ids = list_of_tags_ids.filter(userId => userId !== this.user?.id)

    console.log("Array of tags ", list_of_tags_ids);

    // if (this.isPreview) {
    //   return false
    // }
    // if (this.isLoading) {
    //   return false
    // }
    this.isLoading = true
    this.complexItems?.forEach(element => {
      const username = element.username.toString().trim();
      const formattedUsername = username
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
      const exactMention = `@${formattedUsername}`;
      const regex = new RegExp(`(?<!\\w)${exactMention}(?!\\w)`, 'g');
      if (regex.test(this.replyText)) {
        const replaceValue = `<span id="${element.id}"><strong id="${element.id}">${formattedUsername}</strong></span>`;
        formatedText = this.replyText.replace(regex, replaceValue);
      }
    });
    //this.replyText=formatedText;
    this.unloadReply();
    if (formatedText) {
      this.cachedReplyText = formatedText;
    }
    if (this.replyTo) {
      this.isLoaded =true;
      let replyType;
      if(this.replyTo.replyType=="action_reply"){
        replyType = "action_sub_reply"
      }else if(this.replyTo.replyType=="question_reply"){
        replyType = "question_sub_reply"
      }else{
        replyType = "habit_sub_reply"
      }
      let userIdsToNotify = list_of_tags_ids?.length > 0 
        ? list_of_tags_ids 
        : (this.replyTo?.user?.id === this.user?.id || this.replyTo?.user?.id === this.user?._data?.id) 
          ? [] 
          : [this.replyTo?.user?.id];
       let input = {
          screen_content_id: this.singleRoutineAnswer?.screenContentId,
          root_id: this.replyTo.id,
          reply_text: this.cachedReplyText,
          reply_type: replyType,
          reply_level: 2,
          user_ids: userIdsToNotify,
          comment_type:list_of_tags_ids?.length>0?'tag':'comment',
          is_translate: this.appState.get('selectedLanguage')? true:false
        }
      this.kyperService.postKyperUserReplies(input).subscribe((reply) => {
          this.ishideComment = true;
           const parentReplyId = this.replyTo.id;
          this.replyTo = null;
          this.replyToId = null;
          this.appState.set('isReplyAnimationApplied',true);
          this.reset()
          this.isLoading = false
          this.toastrService.success(this.i18n.t('Comment posted!'))
          this.replyComponent.replyText = '';
          this.replyComponent.isLoaded = true;
          this.replyComponent.isMobileLoaded=true
          //this.getRoutineDetails()
          this.loadReply()
          // this.orderingSubReplies(reply)
         
          const normalizedSubReply = this.normalizeLevel2Reply(reply.data);
          this.repliesTree = this.insertLevel2Reply(parentReplyId, normalizedSubReply, this.repliesTree);
          // this.appState.set('repliesTreeObject', this.repliesTree);
          this.isLoading = true;
          this.data.replies = this.repliesTree;
          this.cdRef.detectChanges()
        },
          (error) => {

            this.toastrService.error(this.i18n.t('Comment not posted. Check your connection and try reloading the app.'), this.i18n.t('Error'))
            this.isLoading = false
            this.isLoaded = true;
            this.isTextboxHide = true;
            this.appState.set("isAnimationApplied", true);
            this.appState.set("isMobileReply", false);
            this.loadReply()
            this.cdRef.detectChanges()
          })
    } else {
     // The backend only pushes to user_ids, so without tags the habit owner must be added
     // explicitly (same as sub-replies do for the replied-to user), unless they're commenting on their own habit.
     let userIdsToNotify = list_of_tags_ids?.length > 0
        ? list_of_tags_ids
        : (!this.singleRoutineAnswer?.user_id || this.singleRoutineAnswer?.user_id === this.user?.id || this.singleRoutineAnswer?.user_id === this.user?._data?.id)
          ? []
          : [this.singleRoutineAnswer?.user_id];
     let input = {
          step_id: this.singleRoutineAnswer?.stepId,
          screen_id: this.singleRoutineAnswer?.screenId,
          screen_content_id: this.singleRoutineAnswer?.screenContentId,
          answer_text: this.cachedReplyText,
          is_translate: this.appState.get('selectedLanguage')? true:false,
          user_ids: userIdsToNotify,
          comment_type: list_of_tags_ids?.length > 0 ? 'tag' : 'comment',
          habit_id: this.singleRoutineAnswer?.habit_id,
          habit_user_id: this.singleRoutineAnswer?.user_id
        }
        this.kyperService.postKyperUserComment(input).subscribe((reply) => {
          this.appState.set('currentActionPoints', reply?.data?.replyQuestion?.actionPoints)
          this.ishideComment = true;
          this.replyTo = null;
          this.replyToId = null;
          this.appState.set('isAnimationApplied',true);
          this.reset()
          this.isLoading = false
          this.loadReply()
          // this.getRoutineDetails()
          // this.orderingSubReplies(reply.data.replyQuestion.reply);
          const normalizedReply = this.normalizeLevel1Reply(reply.data);
          this.repliesTree = [normalizedReply,...(this.repliesTree ?? [])];
          // this.appState.set('repliesTreeObject', this.repliesTree);
          this.isTextboxHide = true;
          this.data.replies = this.repliesTree;
          this.appState.set("isMobileReply", false);
          this.data.replyCount = this.data.replyCount+1;
          this.replyCount = this.data.replyCount;
          this.isLoading = true;
          this.cdRef.detectChanges()
          console.log('reply response', reply);
          this.isLoaded =true
          this.toastrService.success(this.i18n.t('Comment posted!'))
          // if(this.repliesContainer!= undefined){
          //   this.repliesContainer.nativeElement.scrollIntoView()
          //   this.repliesContainer.nativeElement.scrollTop = 0
          // }



        }, error => {
          console.log(error)
          this.loadReply()
          this.cdRef.detectChanges()
          this.isLoaded = true;

          this.toastrService.error(this.i18n.t('Comment not posted. Check your connection and try reloading the app.'), this.i18n.t('Error'))
          this.isLoading = false

        })
    }
  }

  normalizeLevel1Reply(raw: any): any {
    return {
      id: raw.questionId ?? raw.id ?? this._optimisticIdCounter--,
      replyText: raw.replyText ?? raw.answerText,
      replyLevel: 1,
      replyType: raw.replyType ?? 'action_reply',

      pathId: raw.pathId,
      stepId: raw.stepId ?? null,
      screenId: raw.screenId,
      screenContentId: raw.screenContentId,

      likes: [],
      replies: [],
      replyVotesCount: 0,
      hasVoted: false,
      subReplyCount: 0,

      userId: raw.userId,
      user: raw.user ?? this.user,              // current logged-in user

      createdAt: raw.createdAt ?? new Date().toISOString(),
      timestamp: new Date()
    };
  }

  normalizeLevel2Reply(raw: any): any {
    return {
      id: raw.id,
      replyText: raw.replyText ?? raw.reply_text,
      replyLevel: 2,
      replyType: raw.replyType,

      pathId: raw.pathId,
      screenContentId: raw.screenContentId,
      rootId: raw.rootId ?? raw.root_id,

      likes: [],
      replies: [],

      replyVotesCount: 0,
      hasVoted: false,

      userId: raw.userId,
      user: raw.user ?? this.user,

      createdAt: raw.createdAt ?? new Date().toISOString(),
      timestamp: new Date()
    };
  }

  insertLevel2Reply(parentReplyId: number, subReply: any, repliesTree: any[]): any[] {
    this.isLoaded =true;
    this.isTextboxHide = true;
    this.appState.set("isMobileReply", false);
    // this.data.replyCount = this.data.replyCount+1;
    const parentIndex = repliesTree.findIndex(r => r.id === parentReplyId);
    if (parentIndex === -1) return repliesTree;
    const parent = repliesTree[parentIndex];
    const updatedReplies = [subReply, ...(parent.replies || [])];
    const updatedParent = {
      ...parent,
      replies: updatedReplies,
      subReplyCount: updatedReplies.length
    };
    const remainingReplies = repliesTree.filter(r => r.id !== parentReplyId);
    return [updatedParent, ...remainingReplies];
  }

  translate($event){
    let toggleEnabled = $event.detail.checked
    console.log('toggleEnabled :', toggleEnabled);

    if (toggleEnabled === true) {
      this.isTranslated =true;
      this.flag =false;
      console.log('repliesTree before translation:', this.repliesTree);
      this.path = this.appState.get("currentPath");
      const repliesIds = this.repliesTree.map((reply) => reply.id);
      this.translationService
        .loadRepliesTranslations(repliesIds, this.path.language)
        .subscribe((translations) => {
          this.repliesTree.forEach((reply) => {
            const key = `Reply:${reply.id}`;
            reply.text = translations[key].text;
            this.isTranslated =false;
            this.flag = true
            this.cdRef.detectChanges()
          });
        });
      console.log('this.repliesTree after translation:', this.repliesTree);
    }

    else {
      this.flag = false;
      this.appState.set('commentDeleted', true)
      this.cdRef.detectChanges()
    }
  }

  reset() {
    this.replyText = "";
    this.attachmentUrl = null;
    if (this.uploader) {
      this.uploader.reset();
    }
    this.cachedReplyText = "";
  }

  // LUMBA-1383
  loadReply() {
    if (this.cachedReplyText) {
      this.replyText = this.cachedReplyText;
      this.cachedReplyText = "";
    }
  }

  // LUMBA-1383
  unloadReply() {
    this.cachedReplyText = this.replyText;
    this.replyText = "";
  }

  setReplyTo(replyComponent: ReplyComponent) {
    if (this.uploader) {
      this.uploader.reset();
    }
    // This code was needed when all replies was visible
    // Now all replies hidden except selected for reply
    if (this.replyToComponent) {
    }
    if(replyComponent?.selected){
      this.txtarea_post.nativeElement.focus();
    }
    this.replyToComponent = replyComponent;
    if (replyComponent) {
      this.replyTo = replyComponent.reply;
      this.replyToId = this.replyTo.id;
    } else {
      this.replyTo = null;
      this.replyToId = null;
    }
  }

  refresh() {
    console.log(this.router.url);
    this.apollo.getClient().clearStore();
    this.appState.refreshMainComponent.emit();
  }

  scrollTo(event) {
    if (this.cordovaService.onCordova) {
      console.log("click event");
      console.log(this.replyBlock.nativeElement.offsetTop);

      setTimeout(() => {
        window.scrollTo({
          top: this.replyBlock.nativeElement.offsetTop - 160,
          behavior: "smooth",
        });
      }, 10);
    }
  }

  close() {
   
    this.modalController.dismiss()
   
  }

  totalLikes(items) {
    return items.reduce((a, b) => +a + +b.replyVotesCount, 0);
  }

  clickOnInput() {
    this.txtarea_post.nativeElement.focus();
  }

  toggleVote(reply) {
   
    if (this.isMobile) {
      this.bounceAnimation()
    }

    this.voteLoading = true;
    reply.hasVoted = !reply.hasVoted;
    // reply.votescount += reply.hasVoted ? 1 : -1;
    if(!reply.replyVotesCount) {
      reply.replyVotesCount =0
    }
    reply.replyVotesCount += reply.hasVoted ? 1 : -1
    if(reply.hasVoted)
    {
      reply.likes?.push(this.user._data);
      this.data.likes = reply.likes;  
            this.singleRoutineAnswer.likes = reply.likes; 

    }
    else {
      reply.likes?.forEach( (user, index) => {
        if(user.id === this.user?._data.id) 
        reply.likes?.splice(index,1);
      });
      this.data.likes = reply.likes;  
      this.singleRoutineAnswer.likes = reply.likes; 

    }
    this.cdRef.detectChanges();
    let likesData = {
        // user_id: this.user.id,
        path_id: this.path.id,
        post_id: reply.id,
        screen_content_id: reply.screenContentId
      }
      this.kyperService.postKyperUserLikes(likesData).subscribe({
        next: (res) => {
          reply.hasVoted = res.data.voteStatus;
          reply.replyVotesCount = res.data.totalLikes;
          this.cdRef.detectChanges();
        },
        complete: () => {
          this.voteLoading = false;
          this.cdRef.detectChanges();
        },
        error: () => {
          this.voteLoading = false;
        }
      });
  }

  complexItems = this.appState.get("userlist")

  tempValue = 0
  index = 0

  format(item: any) {
    var data = item['id']
    setTimeout(() => {
      SessionService.setData(data)
      //  this.tagName_id = item['id'];
      console.log("Format data ", SessionService.getData());
    }, 100);
    const username = item['username'].toString();
    const formattedUsername = username
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    return `@${formattedUsername}`;
    //return item['username'].toUpperCase()
  }

  mentionConfig: any = {
    mentions: [
      {
        items: this.complexItems,
        labelKey: 'username',
        mentionSelect: this.format,
        dropUp: true
      }
    ]
  };


  focusComment() {
    if (this.appState.get('commentClicked')) {
      this.appState.set('commentClicked', false)
        this.txtarea_post.nativeElement.focus();
     
    }
    else {
      this.txtarea_post.nativeElement.blur();
    }
  }

  bounceAnimation() {
    this.render.addClass(this.btn.nativeElement, 'bounce');
    if(this.btn.nativeElement.querySelector('ion-icon').getAttribute("name") == 'star-outline') {
      this.render.setAttribute(this.btn.nativeElement.querySelector('ion-icon'),"name", 'star')
    }
    else {
      this.render.setAttribute(this.btn.nativeElement.querySelector('ion-icon'),"name", 'star-outline')

    }
    setTimeout(() => {
      this.render.removeClass(this.btn.nativeElement, 'bounce');
    }, 200);
  }

  showLikeList(postId: number, mode: string) {
    this.mobileService.setIsLikeList(true)
    this.mobileService.setPostId(postId)
    this.mobileService.setMode(mode)
    this.homeUiService.openNextComponent(AlertUserLikeListComponent,'','alert-like-modal');
    // var dialog = this.dialog.open(AlertUserLikeListComponent, {
    //   panelClass: 'custom-dialog-container'
    // }
    // )
  }

  showCommentList(mode: string, id: number) {

    const requestUserList = {
      id: id,
      path_id: this.path.id,
      mode: mode
    }
    this.mobileService.setIsLikeList(false)
    this.mobileService.setRequestUserList(requestUserList)
    this.homeUiService.openNextComponent(AlertUserLikeListComponent,'','alert-like-modal');
    // var dialog = this.dialog.open(AlertUserLikeListComponent, {
    //   panelClass: 'custom-dialog-container'
    // }
    // )
  }

  getRoutineText(routine) {
    if (routine.routineAnswer && routine.routineAnswer.routineDescription) {
      return routine.routineAnswer.routineDescription;
    } else {
      return ''
    }
  }

  getImageUrl(item) {
    if (item && item.user && item.user.image_url) {
      return item.user.image_url
    } else {
      return ''
    }
  }

  getUserName(item) {
    if (item && item.user && item.user.first_name && item.user.last_name) {
      return item.user.first_name + item.user.last_name
    } else {
      return ''
    }
  }



  @HostListener('click', ['$event'])
  onLinkClick(e) {
    console.log("Link data ", e);

    if (e.target.tagName.toLowerCase() === 'a' && e.target.target === '_blank') {
      if (this.cordovaService.onCordova) {
        console.log('cordova click')
        e.stopPropagation()
        e.preventDefault()
        this.cordovaService.openLinkInBrowser(e.target.href)
      } else {
        console.log('cordova not click')
        window.open(e.target.href, '_blank')
      }
    }
    if(e.target.tagName.toLowerCase() === 'span' || e.target.tagName.toLowerCase()=='strong'){
      if (e?.target?.id || e.target?.parentElement.id) {
        this.getUserData(e, e.target.id? e.target.id: e.target?.parentElement.id);
      }
    }
  }
  getUserData(event, id) {
    this.routineService.getUserDetailsById(id).subscribe(value => {
      console.log('userid....', value);
      this.openuserInfo(event, value.data?.[0]);
    });
  }
  async openuserInfo(ev, userData): Promise<void> {
    console.log('userData', userData);
    const popover = await this.popoverController.create({
      component: UserPublicProfileComponent,
      event: ev,
      mode: 'ios',
      translucent: false,
      componentProps: { 'user': userData }
    });
    await popover.present();

  }

  onClick(): void {
    this.h1.nativeElement.scrollIntoView({
      top: this.h1.nativeElement.offsetTop,
      behavior: 'smooth'
    });
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    const offset = this.window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (offset > 100) {
      this.isScrolledBottom = true
    } else {
      this.isScrolledBottom = false
    }
  }
  doInfinite(event) {
    console.log('doInfinite :');
    this.getRoutineDetails(event);
  }

  async getRoutineDetails(post): Promise<any> {
    if (!this.singleRoutineAnswer) {
      //this.spinnerService.off()
      this.isLoaded = true;
      return
    }
    let replyId;
    if (event != null || event != undefined || (this.data?.replies?.length>0 && event== this.data?.replies[0]?.id )) {
       replyId= event
    }
   return new Promise( async (resolve, reject) => {
    try {
      let data
      // if (replyId) {
      //   data = {
      //   id: this.singleRoutineAnswer.routine_info_id,
      //   routine_answer_id: this.singleRoutineAnswer.id,
      //   mode: this.singleRoutineAnswer.type,
      //   path_id: this.path.id,
      //   page: this.page,
      //   reply_id: replyId
      //   }
      // }
      // else {
      //   data = {
      //   id: this.singleRoutineAnswer.routine_info_id,
      //   routine_answer_id: this.singleRoutineAnswer.id,
      //   mode: this.singleRoutineAnswer.type,
      //   path_id: this.path.id,
      //   page: this.page
      // };
      // }
      data = {
            screenContentId: post?.screenContentId ?? this.singleRoutineAnswer?.screenContentId,
              path_id: this.path.id,
              page: this.page,
              user_id: post?.user_id ?? this.singleRoutineAnswer?.user_id,
              habit_id: post?.habit_id ?? this.singleRoutineAnswer?.habit_id
          }
        console.log("🚀 ~ FullScreenFeedComponent ~ getHabitDetails ~ data:", data)
       await this.routineV2Service.getKyperPostRepliyDetailsById(data).subscribe(
        (response) => {
          console.log("🚀 ~ FullScreenRoutineComponent ~ getRoutineDetails ~ response:", response)
          console.log("🚀 ~ FullScreenRoutineComponent ~ getRoutineDetails ~ this.singleRoutineAnswer:", this.singleRoutineAnswer)
          this.appState.set('isMobileReply',false)
          this.isLoaded =true;
          this.isTextboxHide =true;
          let postResponse = response.replies[0]
           this.userDetails = response.replies[0].userAnswers;
          // this.userDetails.user_bg_color= response?.data?.routine_color
          this.data.replyVotesCount= postResponse.replyVotesCount;
          console.log("🚀 ~ FullScreenRoutineComponent ~ getRoutineDetails ~ postResponse.replyVotesCount:", postResponse.replyVotesCount)
          this.data.replyCount = postResponse.replyCount;  
          this.singleRoutineAnswer.replyVotesCount= response.replies[0].userAnswers.voteCount;
          console.log("🚀 ~ FullScreenRoutineComponent ~ getRoutineDetails ~ this.singleRoutineAnswer.replyVotesCount:", this.singleRoutineAnswer.replyVotesCount)
          this.singleRoutineAnswer.replyCount = postResponse.replyCount;  
          console.log("🚀 ~ FullScreenRoutineComponent ~ getRoutineDetails ~ this.singleRoutineAnswer.replyCount:", this.singleRoutineAnswer.replyCount)
          let replies = response.replies[0].userAnswers
            var level1;
             if(this.page ==1) {
                this.apiRepliesCount = 0;
               this.repliesTree = [];
             }
            if (this.page == 1 && response.replies[0].userAnswers.replies?.length > 0) {
              this.repliesTree = [];
              level1 = response.replies[0].userAnswers.replies;
            }
            else if (response.replies[0].userAnswers.replies?.length > 0) {
              level1 = this.repliesTree.concat(response.replies[0].userAnswers.replies);
            }
            this.replyCount = postResponse.replyCount;  
            this.apiRepliesCount += response.replies[0].userAnswers.replies?.length;
            this.repliesTree = (level1 ?? replies).filter((reply: any) => reply.id && (reply.replyLevel === 1 || reply.level === 1))
            this.appState.set('repliesTreeObject', this.repliesTree);
            this.singleRoutineAnswer.replies = this.repliesTree;
            this.data.replies =this.repliesTree;
              this.appState.set('repliesLength', this.repliesTree.length)
              let isCommentDeleted = this.appState.get('commentDeleted')
              if (isCommentDeleted) {
                this.appState.set('commentDeleted', false)
              }
        },
        (error) => {
          this.isLoaded =true;
          this.isTextboxHide =true;
          this.appState.set('isMobileReply',false)
          console.log('error', error)
          this.toasterService.error(this.i18n.t("Server or connection issue. Please check your internet connection."))
          //this.spinnerService.off()
        }
      )
        resolve(true);
    } catch (error) {
      this.isLoaded =true;
      this.isTextboxHide =true;
      this.appState.set('isMobileReply',false)
      console.log('error', error)
      reject(error);
      this.toasterService.error(this.i18n.t("Server or connection issue. Please check your internet connection."))
      //this.spinnerService.off()
    }
  });


  }

  sortRepliesBy(key = 'timestamp') {
    this.repliesTree.sort((a, b) => a[key] > b[key] ? -1 : a[key] < b[key] ? 1 : 0)
    this.cdRef.detectChanges();
  }

  translatePost(language: string,text: any){

    let data = {
      language: language,
      text: text
    }

    this.mobileService.translateContent(data).subscribe(
      (response) => {
        console.log('response :', response);
        if(response.status){
          this.replyText = response.data.text
          this.cdRef.detectChanges()
          this.toastrService.success(this.i18n.t('Post translated successfully!'))
        }
      },
    (error) => {
      this.toastrService.error(this.i18n.t('Text translation failed!'))
      console.log("TranslationService data ",error);
    }
    )
  }

}
